<template>
    <header class="app-header">
        <div class="header-content">
            <div class="topCon">
                <div class="topConLeft">
                    <img @click="goHome" class="toplogoimg" src="@/assets/logo.png" alt="">
                    <div class="topConLefts"></div>
                    <div class="topConLeftText">优质冻品 · 专业批发 · 品质之选 · 一站式供应链</div>
                </div>
                <!-- <div class="topConR">
                    <img class="topRphoneimg" src="@/assets/phone.png" alt="">
                    <div class="topConRText">
                        <div>加盟热线：</div>
                        <div class="phone">156 3828 0025</div>
                    </div>
                </div> -->
                <div class="topConR">
                    <div @click="goLogin" style="margin-right: 10px;">我的订单</div>
                    <div v-if="avatar"><img style="width: 36px;height: 36px;border-radius: 50%;margin-left: 10px;"
                            :src="avatar" alt=""></div>
                    <div style="margin-left: 5px;margin-right: 20px;" @click="goLogin">{{ userName ? userName : '登录' }}
                    </div>
                    <div v-if="userName" @click="loginOut">退出</div>
                </div>
            </div>
            <!-- 导航菜单 -->
            <nav class="nav-menu">
                <router-link to="/home" active-class="active" exact>首页</router-link>
                <router-link to="/products" active-class="active">主营产品</router-link>
                <router-link to="/about" active-class="active">关于我们</router-link>
                <!-- <div class="login" @click="goLogin">登录</div> -->
            </nav>
        </div>
    </header>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { userInfo, logout } from '@/api/index'
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'

// 获取 router 实例
const router = useRouter();

const goLogin = () => {
    router.push('/order');
};

let userName = ref()
let avatar = ref('')

// 获取用户信息
userInfo().then(res => {
    userName.value = res.data.nickname
    avatar.value = res.data.avatar
})

// 退出登录
const loginOut = () => {
    ElMessageBox.confirm(
        '你确定要退出登录吗？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            logout().then(res => {
                console.log(res)
                ElMessage.success("操作成功！")
                userName.value = ""
                avatar.value = ""
                localStorage.removeItem('token')
            }).catch(err => {
                console.log(err)
            })
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: '已取消',
            })
        })
}

const goHome = () => {
    router.push('/');
}
</script>

<style scoped lang="scss">
.app-header {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;

    .header-content {
        margin: 0 auto;
        height: 100%;
        display: flex;
        flex-direction: column;

        .topCon {
            background-color: #FFFFFF;
            padding: 15px 140px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .topConLeft {
                display: flex;
                align-items: center;

                .toplogoimg {
                    cursor: pointer;
                    width: 134px;
                    height: 38px;
                    margin-right: 40px;
                }

                .topConLefts {
                    width: 1px;
                    height: 20px;
                    background-color: #CCCCCC;
                }

                .topConLeftText {
                    font-size: 20px;
                    // font-weight: 400;
                    color: #333333;
                    margin-left: 40px;
                }
            }

            .topConR {
                display: flex;
                align-items: center;
                font-size: 18px;
                cursor: pointer;

                .topRphoneimg {
                    width: 46px;
                    height: 46px;
                    margin-right: 14px;
                }

                .topConRText {
                    font-weight: 400;
                    font-size: 22px;
                    color: #707070;

                    .phone {
                        font-weight: bold;
                        font-size: 22px;
                        color: #000000;
                    }
                }
            }
        }

        .nav-menu {
            display: flex;
            // height: 50px;
            gap: 30px;
            padding: 0 340px;
            padding-top: 20px;
            padding-bottom: 20px;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            display: flex;
            background-color: #DB2C23;

            .login {
                position: absolute;
                right: 40px;
                bottom: 25px;
                cursor: pointer;
            }
        }

        .nav-menu a {
            color: rgba(255, 255, 255, 0.8);
            text-decoration: none;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            padding-bottom: 10px;
            transition: all 0.3s;
            margin-right: 150px;
        }

        /* 选中状态样式 */
        .nav-menu a.active // ,.nav-menu a:hover

            {
            font-weight: 800;
            font-size: 16px;
            position: relative;
        }

        .nav-menu a.active::after //,.nav-menu a:hover::after 

            {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 16px;
            height: 2px;
            background-color: #FFFFFF;
        }
    }
}
</style>